import React from "react";
import { useTranslation } from "react-i18next";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import Button from '@/components/Button';
import rem from '@/utils/rem.js'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconWarningCircle } from '@/assets/svgs/icon-warning-circle.svg';
import { ReactComponent as IconSourceSystem } from '@/assets/svgs/source-system-default.svg';

export const SetDefaultSourceSystemModal = ({
    visible,
    hide,
    handleSubmit,
}) => {
    return (
        <Modal visible={visible} variant="medium" close={hide}>
            <CardConfigure >
                <CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon DS__icon--theme'}>
										<IconSourceSystem />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Set Default Source System
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
                </CardConfigure.Header>
                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        <div className="default-source-system">
                            <div className="default-source-system__message">Are you sure to set this Source System as default?</div>
                            <div className="default-source-system__alert">
                                <IconWarningCircle />
                                <div className="default-source-system__alert__message">By setting this Source System as default, your previous
                                    <br />default will be overwritten
                                </div>
                            </div>
                        </div>
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>
                <CardConfigure.Footer>
                    <CardConfigure.Footer.Left>
                        <Button
                            customeHover
                            btnText
                            id="set-default-ss-modal-cancel-btn"
                            text="Cancel"
                            submit={() => hide()}
                        />
                    </CardConfigure.Footer.Left>
                    <CardConfigure.Footer.Right>
                        <Button text="Confirm"
                            round
                            id="set-default-ss-modal-confirm-btn"
                            data-testid="set-default-ss-modal-confirm-btn"
                            submit={() => {
                                handleSubmit();
                            }} />
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    )
};
